import { render, staticRenderFns } from "./Component3.vue?vue&type=template&id=38910960&scoped=true&"
import script from "./Component3.vue?vue&type=script&lang=js&"
export * from "./Component3.vue?vue&type=script&lang=js&"
import style0 from "./Component3.vue?vue&type=style&index=0&id=38910960&prod&lang=scss&scoped=true&"
import style1 from "./Component3.vue?vue&type=style&index=1&id=38910960&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38910960",
  null
  
)

export default component.exports